import { Divider as AntdDivider } from 'antd';
import { createGuardedComponent } from '../../provider/create-guarded-component';

export type { DividerProps } from 'antd';

export const Divider = createGuardedComponent(AntdDivider);
